import { ChakraBox, ChakraFlex, EquipUIFireflyV2Theme } from '@equip.health/ui';
import { DateTime } from 'luxon';
import { useHistory } from 'react-router-dom';

import { OverviewPageEvents } from '~/analytics/overviewPageEvents';
import AppointmentTime from '~/components/common/calendar/review/AppointmentTime';
import ScheduleDayCardSummary from '~/components/common/calendar/schedule/day-view/ScheduleDayCardSummary';
import NoData from '~/components/common/NoData';
import { CalendarListTypeOption } from '~/lib/constants/appointment.constants';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import Loading from '~/pages/loading';
import { Path } from '~/routes/constants';

const TOP_LEVEL_ID = 'upcoming-events';

interface UpcomingEventsProps {
  events: ScheduleItemBase[];
  linkTo: string;
  loading: boolean;
  patientId: string;
}

const { neutral } = EquipUIFireflyV2Theme.colors;

const UpcomingEvents = ({
  events,
  linkTo,
  loading,
  patientId,
}: UpcomingEventsProps) => {
  const history = useHistory();
  const { trackEvent } = useAnalytics();
  const linkToFunc = (date: string) => {
    trackEvent(OverviewPageEvents.uniqueEventsOverviewTabButtonClicked, {
      Source: AnalyticsSourceValues.OVERVIEW_TAB,
    });
    const isoDate = DateTime.fromISO(date).toISODate();
    history.push(
      `${Path.MAUD_PATIENTS}/${patientId}/${linkTo}/${CalendarListTypeOption.DAILY_VIEW}?date=${isoDate ?? date}`,
    );
  };

  if (loading) return <Loading />;

  return (
    <>
      {events.length > 0 ? (
        <ChakraBox id={TOP_LEVEL_ID} marginTop="24px">
          {events.map((event, index) => (
            <ChakraFlex
              border={`1px solid ${neutral.line}`}
              borderRadius="16px"
              cursor="pointer"
              id={`${TOP_LEVEL_ID}__${event.startDateTime}`}
              key={index.toString()}
              marginBottom="12px"
              onClick={() => linkToFunc(event.startDateTime)}
              padding="24px"
            >
              <ChakraBox width="30%">
                <AppointmentTime
                  appointmentTimeIcon={event.icon}
                  end={event.endDateTime}
                  start={event.startDateTime}
                />
              </ChakraBox>
              <ChakraBox width="70%">
                <ScheduleDayCardSummary isLinkDetail scheduleItem={event} />
              </ChakraBox>
            </ChakraFlex>
          ))}
        </ChakraBox>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default UpcomingEvents;
